import { useEffect, useState } from "react";
import {
  AllCommunityModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  ValidationModule,
} from "ag-grid-community";
import {
  CellSelectionModule,
  ClipboardModule,
  RowGroupingModule,
  RowGroupingPanelModule,
} from "ag-grid-enterprise";
import { ExcelExportModule } from "ag-grid-enterprise";
import { ColumnBuilder } from "./ColumnBuilder";
import { _ROUTES } from "../../../utils/_routes_constants";
import { _COLORS } from "../../../utils/constants";
import { DataTable } from "../../ui/DataTable";
import { useSalesOnCellValueChanged } from "./useSaveSalesOnCellChanged";
import { addblankLine } from "../../../utils/function";
import { DataService } from "../../../services/DataService";
import { defaultExcelStyle } from "../../../utils/AgGridUtils/defaultExcelStyle";
import { parseInternationalNumber } from "../BaseBudgetSaveFunctions";

ModuleRegistry.registerModules([
  AllCommunityModule,
  ExcelExportModule,
  ClientSideRowModelModule,
  ValidationModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  CellSelectionModule,
  ClipboardModule,
]);

export const _EXT_CASH = "External cash";
export const _EXT_CREDIT = "External credit";
export const _INT = "Internal";
export const _VOL = "Volume";
export const _TOT_QTY = "Total Qty";
export const _EXTERNAL_ROWS = [
  "Aggregates",
  "Crusher Run",
  "Rocksand",
  "Spalls filters boulders",
];

/**
 * @TODO :
 *
 *
 * @param {string}params.site
 * @param {string} params.fiscalYear
 * @param {string} params.version
 * */
export const AgGridSalesDepot = ({ params, gridRef }) => {
  const dataService = new DataService();
  const [rowsData, setRowsData] = useState([]);
  const [pendingRefresh, setPendingRefresh] = useState(false);
  const [groupNameProdSplit, setGroupNameProdSplit] = useState(null);
  const [columns, setColumns] = useState(() =>
    ColumnBuilder({}, groupNameProdSplit),
  );

  useEffect(() => {
    dataService.fetchData(_ROUTES.IPT_SALES_DEPOT_DATA, params, (data) => {
      setRowsData(addblankLine(data));
      const prodSplitGroup = data.find((e) =>
        e.group.startsWith("Production"),
      )?.group;

      setGroupNameProdSplit(prodSplitGroup);

      setColumns(ColumnBuilder({}, prodSplitGroup));
    });
  }, [pendingRefresh, params]);

  const onCellValueChanged = useSalesOnCellValueChanged(
    params,
    setPendingRefresh,
  );

  const defaultColDef = {
    valueParser: (params) => {
      // Parser pour tous les champs éditables numériques
      if (params.colDef.editable && typeof params.newValue === "string") {
        return parseInternationalNumber(params.newValue);
      }
      return params.newValue;
    },
    cellClassRules: {
      "blank-row": (params) => {
        return params.data?._SPACER;
      },
      "total-header-col": (params) => {
        return params.colDef.field === "total";
      },
      "production-split": (params) => {
        return (
          params.colDef.field === "total" &&
          params.data?.group === groupNameProdSplit
        );
      },
      "row-volume": (params) => {
        return params.data?.group === _VOL && params.data?.rowName !== _TOT_QTY;
      },
      "total-row": (params) =>
        params.node && params.node.aggData && params.node.footer,
      "editable-cell": (params) => {
        // !params.data = header group rown
        if (!params.data || params.colDef.field === "total") {
          return false;
        }

        return (
          params.data.rowName === _INT ||
          _EXTERNAL_ROWS.includes(params.data.rowName) ||
          params.data.group === _VOL
        );
      },
    },
  };

  const excelStyles = defaultExcelStyle([
    {
      id: "production-split",
      interior: {
        color: _COLORS.productionSplit,
        pattern: "Solid",
      },
    },
    {
      id: "row-volume",
      interior: {
        color: _COLORS.volumeRow,
        pattern: "Solid",
      },
    },
  ]);

  return (
    <>
      <DataTable
        rows={rowsData}
        columns={columns}
        excelStyles={excelStyles}
        onCellValueChanged={onCellValueChanged}
        fullHeight={true}
        rowHeight={30}
        fileNameCsvExport={"sale-depot"}
        gridRef={gridRef}
        agGridProps={{
          cellSelection: true,
          copyHeadersToClipboard: false,
          defaultColDef: defaultColDef,
          groupDisplayType: "groupRows",
          groupDefaultExpanded: -1,
          suppressAggFuncInHeader: true,
          suppressClipboardPaste: false,
          enableCellTextSelection: true,
          groupRowRendererParams: {
            suppressCount: true,
          },
          groupTotalRow: (p) =>
            [_EXT_CASH, _EXT_CREDIT].includes(p?.node?.key) ? "top" : undefined,
          getRowClass: (params) => {
            if (
              (params.node && params.node.aggData && params.node.footer) ||
              params.data?.rowName === _TOT_QTY
            ) {
              return "total-row";
            }

            if (!params.data) return "header-group-row";

            return "";
          },
        }}
      />
    </>
  );
};
